<!-- Clickable dropdown menu item that emits a click action, with optional icon and destructive variant. -->

<script lang="ts" setup>
import { defineProp } from '@nzyme/vue-utils/defineProp.js';
import { DropdownMenuItem } from 'reka-ui';
import type { Component, PropType, VNodeChild } from 'vue';

import css from './Dropdown.module.scss';
import DropdownItemContent from './DropdownItemContent.vue';

type DropdownActionVariant = 'default' | 'destructive';

interface Slots {
  default: () => VNodeChild;
  help: () => VNodeChild;
}

defineProps({
  variant: {
    type: String as PropType<DropdownActionVariant>,
    default: 'default',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  icon: defineProp<Component>(),
});

defineEmits(['click']);
defineSlots<Slots>();
</script>

<template>
  <DropdownMenuItem
    :class="[css.item, variant && css[`variant-${variant}`], disabled && css.disabled]"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <DropdownItemContent :icon="icon">
      <slot />

      <template
        v-if="$slots.help"
        #help
      >
        <slot name="help" />
      </template>
    </DropdownItemContent>
  </DropdownMenuItem>
</template>
